import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "../../shared/Navbar";
import Footer from "../../shared/Footer";
import { IMAGES } from "../../../../assets";
import About from "./About";
import Features from "./Features";
import EaseOfSearch from "./EaseOfSearch";
import Faqs from "./Faqs";
import Statistic from "./Statistic";
import OfferVideo from "./OfferVideo";
import AppStore from "./AppStore";
import { useInView } from 'react-intersection-observer';
import AstrologerCard from './AstrologerCard';

const Home = () => {
  const [ref, inView] = useInView({
		triggerOnce: true, // Trigger animation only once
		threshold: 0.3, // Trigger when 10% of the image is visible
	});
  const [homeRef, inHomeView] = useInView({
		triggerOnce: true, // Trigger animation only once
		threshold: 0.3, // Trigger when 10% of the image is visible
	});
  const [imageRef, inImageView] = useInView({
		triggerOnce: true, // Trigger animation only once
		threshold: 0.3, // Trigger when 10% of the image is visible
	});

  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      setTimeout(() => {
        const element = document.querySelector(location.hash);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    }
  }, [location]);
  return (
    <>
      {/* <!--Header  --> */}
      <div className="banner_outer">
        <Navbar />
        {/* <!-- Banner --> */}
        <section className="banner-section">
          <div className="container">
            <div className="row">
              <div ref={homeRef} className={`col-lg-6 col-md-6 col-sm-12 col-12 ${inView ? 'animate__animated animate__slideInDown' : ''}`}>
                <div className="banner_content" data-aos="fade-down">
                  <h1>Cosmic Advice</h1>
                  <h3 className="text-white">
                    Decode the Stars. Discover Your Destiny.
                  </h3>
                  <p className="text-white">
                    Unlock the Universe Within — Your Journey to Cosmic Clarity Starts Here!
                  </p>
                  <span>Available on:</span>
                  <div className="image_wrapper">
                    <a href="https://www.apple.com/app-store/">
                      <figure className="mb-0 image_apple">
                        <img
                          className="img-fluid"
                          src={IMAGES.bannerapple_img1}
                          alt=""
                        />
                      </figure>
                    </a>
                    <a
                      className="image_google" target="_blank"
                      href="https://play.google.com/store/apps/details?id=com.cosmicadvice"
                    >
                      <figure className="mb-0 image_google">
                        <img
                          className="img-fluid"
                          src={IMAGES.bannergoogle_img2}
                          alt=""
                        />
                      </figure>
                    </a>
                  </div>
                </div>
              </div>
              <div ref={imageRef} className={`col-lg-6 col-md-6 col-sm-12 col-12 ${inView ? 'animate__animated animate__slideInRight' : ''}`}>
                <div className="banner_wrapper2">
                  <figure className="mb-0 bannerphone1">
                    <img
                      className="img-fluid"
                      src={IMAGES.bannerphone1_img}
                      alt=""
                    />
                  </figure>
                </div>
              </div>
            </div>
            <figure ref={ref} className={`mb-0 bannersidecircle1 ${inView ? 'animate__animated animate__slideInRight' : ''}`} data-aos="fade-left">
              <img src={IMAGES.banner_sidecircle1} alt="" />
            </figure>
            <figure ref={ref} className={`mb-0 bannersidecircle2 ${inView ? 'animate__animated animate__slideInRight' : ''}`} data-aos="fade-left">
              <img src={IMAGES.banner_sidecircle2} alt="" />
            </figure>
          </div>
        </section>
      </div>

      <About/>

      <Features/>

      {/* <AstrologerCard/> */}

      <EaseOfSearch/>
      
      <Statistic/>

      <Faqs/>
      
      <OfferVideo/>

      <AppStore/>

      <Footer />
    </>
  );
};

export default Home;